export interface ClipPathOptions {
    blockData: any;
    item: {
        enableClipPath?: boolean;
        type: string;
    };
    index: number;
    border?: string;
    type: string;
}

export enum ClipPathTypes {
    imageBlock = 'imageBlock',
}
